import { Controller } from 'react-hook-form'
import { FormControlLabel, Grid, Switch, TextField } from '@material-ui/core'

import {
  Card,
  Label,
  PendingBillingEmails,
  Select as SelectComponent,
} from 'components'
import BillingEmails from '../BillingEmails'
import constants from 'constants/index'

const NotificationsAndDeadlines = ({
  control,
  errors,
  paymentServiceTemplateId,
  isEdit,
  emails,
  setEmails,
}) => {
  return (
    <Card title="Notificações e vencimentos">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Controller
                as={<Switch color="primary" />}
                name="enableAdvance"
                control={control}
                onChange={([event]) => event.target.checked}
              />
            }
            label="Notificar vencimento"
          />
        </Grid>
        <Grid item xs={12}>
          <Label title="Antecedência de aviso" marginTopChildren={1}>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12}>
                <Controller
                  as={
                    <TextField
                      label="Valor da antecedência"
                      type="number"
                      fullWidth
                      variant="outlined"
                      error={!!errors.valueAdvance}
                      helperText={errors?.valueAdvance?.message}
                    />
                  }
                  name="valueAdvance"
                  control={control}
                  mode="onBlur"
                  type="number"
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Controller
                  as={
                    <SelectComponent
                      label="Período da antecedência"
                      items={constants.paymentServiceTemplate.PERIOD_OPTIONS}
                      error={!!errors.periodAdvance}
                      helperText={errors?.periodAdvance?.message}
                    />
                  }
                  name="periodAdvance"
                  control={control}
                  mode="onBlur"
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Controller
                  as={
                    <SelectComponent
                      label="Frequência dos disparos"
                      items={constants.paymentServiceTemplate.FREQUENCY_OPTIONS}
                      error={!!errors.frequencyAdvance}
                      helperText={errors?.frequencyAdvance?.message}
                    />
                  }
                  name="frequencyAdvance"
                  control={control}
                  mode="onBlur"
                />
              </Grid>
            </Grid>
          </Label>
        </Grid>
        <Grid item xs={12}>
          {isEdit ? (
            <BillingEmails
              paymentServiceTemplateId={paymentServiceTemplateId}
            />
          ) : (
            <PendingBillingEmails emails={emails} setEmails={setEmails} />
          )}
        </Grid>
      </Grid>
    </Card>
  )
}

export default NotificationsAndDeadlines
